"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectFormModel = exports.IkeObjectForm = void 0;
const base_1 = require("./base");
class IkeObjectForm extends base_1.IkeRestObject {
    constructor() {
        super();
        this.className = 'Form';
        this.actionName = 'form';
        this.cacheKeys['revision'] = true;
        // Required for mapsight-web form designer
        this.cacheKeys['version'] = true;
    }
}
exports.IkeObjectForm = IkeObjectForm;
exports.IkeObjectFormModel = {
    className: 'FormModel',
    actionName: 'form.model',
    canCache(key) {
        return key === 'revision' || key === 'version';
    }
};
//# sourceMappingURL=form.object.js.map